module.exports = __webpack_public_path__ + "img/category.660e0a95.svg";